import { initialLocalState } from './initialeLocalState';
import { ApolloCache } from '@apollo/client';

export const initializeLocalState = (cache: ApolloCache<any>) => {
  return cache.writeQuery({
    query: initialLocalState,
    data: {
      commandes: []
    }
  });
};
